// El marco del asistente de ejemplo (cabecera, compositor y caja de propuesta) se dibuja en el
// héroe (Heroe_B2) y en Poderes_Demo. Su copy vive aquí una sola vez para que las dos ilustraciones
// no puedan contradecirse y el barrido de claims lea una sola fuente (D-22).
export const MARCO_ASISTENTE = {
    nombre: 'Asistente IA',
    alcance: 'Marta Ruiz · todo el historial',
    funciones: 'Funciones',
    marcador: 'Pregunta o pide una acción',
    propuestaPendiente: 'Propuesta · pendiente de tu aprobación',
    botonesPropuesta: ['Aprobar', 'Editar', 'Rechazar'],
} as const;
